
export const useRuntimeConfig = () => window?.__NUXT__?.config || {}
